// ─── FLIP DE PRODUCTO ─────────────────────────────────────────
// Al tocar/Enter sobre el frente, la card voltea y muestra ingredientes,
// porciones y el botón de pedir (un enlace real de WhatsApp). "Volver"
// regresa al frente. Accesible: con `inert`, solo la cara visible es
// enfocable, y el foco se mueve a la cara que aparece.
(() => {
  "use strict";

  const cards = document.querySelectorAll(".product-card");

  cards.forEach((card) => {
    const front = card.querySelector(".product-card__front");
    const back = card.querySelector(".product-card__back");
    if (!front || !back) return;

    const volver = back.querySelector("[data-flip-back]");

    const setFlipped = (flipped) => {
      card.classList.toggle("is-flipped", flipped);
      front.inert = flipped; // la cara oculta no recibe foco ni lectores
      back.inert = !flipped;
    };

    setFlipped(false); // estado inicial: frente visible

    const alFrente = () => {
      setFlipped(false);
      front.focus();
    };
    const alReverso = () => {
      setFlipped(true);
      if (volver) volver.focus();
    };

    front.addEventListener("click", alReverso);
    front.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        alReverso();
      }
    });

    if (volver) volver.addEventListener("click", alFrente);
  });
})();
